export class ImpersonateUser {
    id: string;
    name: string;
    constructor(init?: Partial<ImpersonateUser>) {
        Object.assign(this, init);
    }
}
